<template>
	<div class="accountAdmin">
		<!--导航条-->
		<navZcy v-bind:num="'6-2'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<!--页面标题-->
			<div class="top cf">
				<div class="topL fl"><span>账号设置</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh()"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<div class="handle">
					<div class="">账号设置</div>
				</div>
				<div class="change">
					<div class="">
						<!--上传头像-->
						<el-upload 
							class="avatar-uploader" 
							action="string" 
							:http-request="hashMd5" 
							:show-file-list="false" 
							:before-upload="beforeAvatarUpload">
							<img v-if="imageUrl" :src="imageUrl"  class="avatar" style="width: 100px;height: 100px;">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
					<div class="topClass">上传头像</div>
					<div class="inputOuter">
						<el-input disabled v-model="usr" style="width: 230px;"></el-input>
					</div>
					<div class="inputOuter">
						<el-input v-model="oPwd" type="password" placeholder="旧密码" style="width: 230px;" autofocus></el-input>
					</div>
					<div class="inputOuter">
						<el-input v-model="pwd" type="password" placeholder="新密码" style="width: 230px;"></el-input>
					</div>
					<div class="inputOuter">
						<el-input v-model="confirmPwd" type="password" placeholder="确定密码" style="width: 230px;"></el-input>
					</div>
					<div class="btn">
						<el-button size="medium" @click="back()">取消</el-button>
						<el-button size="medium" @click="modifyAdminPwd" style="background: rgba(26, 188, 156, 1);color: #fff;margin-left: 20px;">确定</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import navZcy from './nav'
export default {
	data() {
		return {
			usr: sessionStorage.getItem("usrName"),
			oPwd: '',
			pwd: '',
			confirmPwd: '',
			imageUrl: 'static/img/top.png',
			uploadImgFile: ""
		};
	},
	methods: {
		//页面刷新
		refresh() {
			location.reload()
		},
		//筛选上传文件格式
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
			const isLt2M = file.size / 1024 / 1024 < 1;

			if(!isJPG) {
				this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
			}
			if(!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 1MB!');
			}
			return isJPG && isLt2M;
		},
		//图片md5值
		hashMd5(item){ 
	    	var vue = this
		   	var fileReader = new FileReader(),   
	        blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,  
	        file = item.file,  
	        chunkSize = 2097152,  
	        // read in chunks of 2MB  
	        chunks = Math.ceil(file.size / chunkSize),  
	        currentChunk = 0,  
	        spark = new SparkMD5();  
		    fileReader.onload = function(e) {  
//		        console.log("read chunk nr", currentChunk + 1, "of", chunks);  
		        spark.appendBinary(e.target.result); // append binary string  
		        currentChunk++;  
		  
		        if (currentChunk < chunks) {  
		            loadNext();  
		        }else {  
//		            console.log("finished loading"); 
					vue.uploadImgFile='/lightApi/upload/image/'+sessionStorage.getItem("sessionId")+"/"+file.type.split("/")[1]+"/"+spark.end()
					vue.uploadItem(vue.uploadImgFile,file)		        	
		        }
		    };
		    function loadNext() {  
		        var start = currentChunk * chunkSize,  
		            end = start + chunkSize >= file.size ? file.size : start + chunkSize;  
		  
		        fileReader.readAsBinaryString(blobSlice.call(file, start, end));  
		    };  		  
		    loadNext(); 
		}, 
		//上传图片
		uploadItem(uploadUrl,file){
			let param = new FormData()  // 创建form对象
		    param.append('file', file, file.name)
			var header = {
                'Content-Type': 'multipart/form-data'
            }
			axios.post(uploadUrl,param,header).then(
				(comments) => {
//					console.log(comments)
					if(comments.data.msg=="上传成功"||comments.data.status==200){
						this.imageUrl = comments.data.data;
					}else{
						this.$message({
							type: 'error',
							message: comments.data.msg
						});
					}											
				}
			)
		},
		//点击取消返回
		back() {
			history.go(-1)
		},
		modifySucceedFn(data){
			if(data.msg=="ok"){
				this.$message({
					type: 'success',
					message: '密码修改成功!'
				});
				this.$router.push({path: '/',query: ''})  					
			}else{
				this.oPwd = ""
				this.$message.error(data.msg);
			}
		},
		//修改密码
		modifyAdminPwd() {
			if(this.pwd.trim()!=""&&this.confirmPwd.trim()==this.pwd.trim()){
				let data = {
					usr: sessionStorage.getItem("usrName"),
					oldPwd: this.oPwd.trim(),
					newPwd: this.pwd.trim()
				}
				let url = "/lightApi/admin/modifyPassowrd/"+sessionStorage.getItem("sessionId")
				this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.modifySucceedFn,'vue':this})				
			}else{
				if(this.pwd.trim()==""){
					this.$message({
						type: 'error',
						message: '新密码不能为空'
					});
				}else{
					this.$message({
						type: 'error',
						message: '新密码与确定密码不相等'
					});
				}
			}
		}
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>
.change {
	text-align: center;
	background: #fff;
	padding: 30px 0;
}	
.topClass {
	color: #64BCA9;
	margin-top: 15px;
}	
.inputOuter {
	padding: 12px 0;
}	
.btn {
	padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/accountAdmin.vue